// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3-7qa","label":"Labeled_label__1Clrm","divider":"Labeled_divider__3rIBc"};